import { ReactNode } from 'react'

import { UseSpkStakingGeneralStatsResult } from '../../logic/useSpkStakingGeneralStats'
import { USD_MOCK_TOKEN } from '@/domain/types/Token'
import { Skeleton } from '@/ui/atoms/skeleton/Skeleton'
import { TokenAmountTooltip } from '@/ui/organisms/token-amount-tooltip/TokenAmountTooltip'
import { cn } from '@/ui/utils/style'

export interface GeneralStatsBarProps {
  generalStatsResult: UseSpkStakingGeneralStatsResult
}

export function GeneralStatsBar({ generalStatsResult }: GeneralStatsBarProps) {
  if (generalStatsResult.isPending) {
    return <Skeleton className="h-10 w-full max-w-[400px]" />
  }

  if (generalStatsResult.isError) {
    return null
  }

  const generalStats = generalStatsResult.data

  return (
    <div className={cn('inline-flex divide-x divide-secondary rounded-[10px]', 'bg-primary/80 py-3 backdrop-blur-lg')}>
      <Stat>
        <Label>Stakers:</Label>
        <Value>{formatUsersNumber(generalStats.stakers)}</Value>
      </Stat>
      <Stat>
        <Label>Total Staked:</Label>
        <Value>
          <TokenAmountTooltip
            token={USD_MOCK_TOKEN}
            amount={generalStats.totalStaked}
            options={{ style: 'compact', showSymbol: 'never' }}
          />
        </Value>
      </Stat>
    </div>
  )
}

export function Stat({ children }: { children: ReactNode }) {
  return <div className="flex gap-1 px-3 sm:px-4">{children}</div>
}

function Label({ children }: { children: string }) {
  return <div className="typography-label-3 text-secondary">{children}</div>
}

function Value({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn('typography-label-3 text-primary', className)}>{children}</div>
}

function formatUsersNumber(users: number): string {
  return Intl.NumberFormat('en-US', { maximumFractionDigits: 0, notation: 'compact' }).format(users)
}
